import React, { createContext, useState, useEffect, useContext } from "react";
import { login } from "../services/loginService";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
  const loggedToken = localStorage.getItem("token");
    if (loggedToken) {
      setToken(loggedToken);
    }
    const loggedInUser = localStorage.getItem("username");
    if (loggedInUser) {
      setUser(loggedInUser);
    }
  }, []);

  const handleLogin = async (username, password) => {
    try {
      const response = await login(username, password);
      if (response) {
        const token = response.token;
        setToken(token);
        setUser(username);
        localStorage.setItem("token", token);
        localStorage.setItem("username", username);
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error("Error al intentar iniciar sesión:", error);
      return false;
    }
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem("username");
    setToken(null);
    localStorage.removeItem("token");
  };

  const refreshToken = (user, token) => {
    setUser(user);
    setToken(token);
    localStorage.setItem("token", token);
    localStorage.setItem("username", user);
  }

  return (
    <AuthContext.Provider value={{ token, user, handleLogin, handleLogout, refreshToken }}>
      {children}
    </AuthContext.Provider>
  );
};
